import { useEffect } from "react";
import { useModalState } from "./ModalStateProvider";

export const useSetModalTitle = (newTitle: string) => {
  const { setTitle } = useModalState();

  useEffect(() => {
    setTitle(newTitle);
  }, [newTitle, setTitle]);
};